export enum ReportDateType {
    Year,
    DateScope
}